import { render } from "./HowItWorksModal.vue?vue&type=template&id=654589b5"
import script from "./HowItWorksModal.vue?vue&type=script&lang=js"
export * from "./HowItWorksModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__